<template>
    <div class="gallery">
        <div class="gallery-img" v-for="(item, idx) in images" :key="idx">
            <img :src="item.src" :alt="item.alt" />
        </div>
    </div>
</template>

<script>
export default {
    name : "Gallery",
    props : ['images']

}
</script>

<style lang="scss" scoped>
.gallery {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
}

.gallery-img {
    margin:5px;
    width:calc(20% - 10px);
}

.gallery-img img {
    width:100%;
}

@media screen and (max-width:768px) {
    .gallery-img {
        margin:5px;
        width:calc(50% - 10px);
    }
}

</style>